<div class="user-preferences-dialog">
  <h2 mat-dialog-title>Preferências</h2>

  <mat-dialog-content>
    <mat-accordion class="mat-elevation-z4">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          Menu lateral
        </mat-expansion-panel-header>

        <mat-slide-toggle [checked]="sidenavCollapsedByDefault"
                           (change)="onChangeSidenavCollapsedByDefault($event.checked)">
          Menu lateral sempre retraído
        </mat-slide-toggle>
      </mat-expansion-panel>

      <mat-expansion-panel>
        <mat-expansion-panel-header>
          Paginação
        </mat-expansion-panel-header>

        <div class="d-flex align-items-center">
          <div class="col-2">
            <mat-form-field>
              <mat-label>
                Itens por página
              </mat-label>
              <input matInput
                     [formControl]="pageSize"
                     (input)="onInputPageSize()"
                     (change)="onChangePageSize()"
                     autocomplete="off">
            </mat-form-field>
          </div>

          <div class="col-2">
            <mat-form-field>
              <mat-label>
                Opções de páginas
              </mat-label>
              <input matInput
                     [formControl]="pageOptions"
                     (input)="onInputPageOptions()"
                     (change)="onChangePageOptions()"
                     placeholder="Ex: 1, 5, 10, 15, 20"
                     autocomplete="off">
            </mat-form-field>
          </div>

          <div class="col-4">
            <mat-checkbox [(ngModel)]="settings.config.pagination.showFirstLastButtons"
                          (change)="settings.save()">
              Mostrar botões para primeira e última página
            </mat-checkbox>
          </div>
        </div>
        <hr>
        <small>Exemplo:</small>
        <mat-paginator [length]="100"
                       [pageSize]="settings.config.pagination.pageSize"
                       [pageSizeOptions]="settings.config.pagination.pageSizeOptions"
                       [showFirstLastButtons]="settings.config.pagination.showFirstLastButtons">
        </mat-paginator>
      </mat-expansion-panel>
    </mat-accordion>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Fechar</button>
  </mat-dialog-actions>
</div>
